import { Component, Input, OnChanges } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    animations: [
        trigger('smoothCollapse', [
            state('initial', style({
                padding: '0',
                height: '0',
                opacity: '0',
                overflow: 'hidden'
            })),
            state('final', style({
                opacity: '1'
            })),
            transition('initial=>final', animate('50ms')),
            transition('final=>initial', animate('50ms'))
        ])
    ],
    standalone: false
})
export class CardComponent implements OnChanges {
  @Input() title: string;
  @Input() updated = null;
  @Input() collapsible = false;
  @Input() color = 'transparent';
  @Input() isCollapsed: false;
  @Input() activeTab: string;
  @Input() isInop: boolean;
  @Input() statusRemark: boolean;

  public nullMessage: string;
  public validDate: boolean;
  public chevronUp = faChevronUp;
  public chevronDown = faChevronDown;

  ngOnChanges() {
    this.validDate = moment(this.updated).isValid();

    if (this.activeTab === 'LOAD_PLANNING') {
      this.nullMessage = this.isInop
        ? 'NOTICE – ALL BINS INOP'
        : 'Interface Failed';
    }

    if (this.activeTab === 'CLOSEOUT') {
      this.nullMessage = 'No Data Received';
    }
  }
}
